import { Routes , Route  } from 'react-router-dom';
import './App.css';
import AboutMe from './Components/AboutMe';
import ContactMe from './Components/ContactMe';
import Gallery from './Components/Gallery';
import Home from './Components/Home';
import NavBar from './Components/NavBar';
import NotFound from './Components/NotFound';

function App() {
  return (
    <>
    <NavBar />
    <Routes>

      <Route path='/' element={<Home />} />
      <Route path='/aboutme' element={<AboutMe />} />
      <Route path='/gallery' element={<Gallery />} />
      <Route path='/contactme' element={<ContactMe />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
    
    </>
  );
}

export default App;
